import { Vector3 } from 'three';
import LPS from '@/domain/anatomy/LPS';

/**
 * The "world up" axis the stock Three.js controls assume (their default).
 * Orbit-spherical math is defined relative to this axis, so any code that
 * uses Three.js's `Spherical` or OrbitControls's internal `_quat` needs to
 * map our orbit axis into this frame before doing the math, then back.
 *
 * Numerically equal to `LPS.Posterior` but conceptually distinct: this is
 * the Three.js convention, not an LPS direction.
 */
export const WORLD_UP = new Vector3(0, 1, 0);

/**
 * The stable orbit axis for the planner: the patient's superior-inferior
 * (spine) axis. Shared by `LpsOrbitControls` (mouse) and `nudgeCamera`
 * (keyboard) so both rotate around the same axis regardless of where
 * `camera.up` is currently pointing.
 *
 * `camera.up` is reserved for screen orientation at snap time; it must not
 * influence the orbit gimbal.
 */
export const ORBIT_AXIS = LPS.Superior;
